import AcompanhamentoVistoriaDesembolso from "../models/acompanhamento-vistoria-desembolso";
import { Anexo } from "../models/anexo";
import { AnexoFotografico } from "../models/anexoFotografico";
import { DetalheComprovacaoFisicaSubmit, ResumoComprovacaoFisica } from "../models/comprovacao-fisica";
import { BaseReferencia, BaseReferenciaSubmit } from "../models/base-referencia";
import { FiltroLaudo } from "../models/filtros/filtro-laudo";
import FiltroLaudoHistorico from "../models/filtros/filtro-laudo-historico";
import { PendenciasArtsRrts, CoordenadasGeodesicas, OrcamentoPropostoVersusReferencia } from "../models/identificacao-obra";
import ImovelLaudo from "../models/imovel-vistoria-desembolso";
import LaudoEdicao from "../models/laudo-edicao";
import SolicitacaoDocumentoPendente from "../models/solicitacao-doc-pendente";
import VistoriaDesembolso from "../models/vistoria-desembolso";
import api from "../services/api-gateway";
import { EsclarecimentoPendencia } from "../models/observacoes-complementares";
import { SugestaoCronogramaDesembolso } from "../models/criticaOrcamentoResultados";
import { EdicaoLaudoAvaliacaoDeQualidadeVO } from "../models/dados-avaliacao-de-qualidade";
import { AvaliacaoAnimais } from "../models/avaliacao-animais";
import Laudo from "../models/laudo";
import DocumentacaoMetodologiaResultado from "../models/DocumentacaoMetodologiaResultado";
import { CoordenadasApascentamento } from "../models/vistoria-animal";
import { Detalhamento } from "../models/Detalhamento";
import MelhoramentosServicosPublicos from "../models/melhoramentos-servicos-publicos";
import UsoPredominante from "../models/uso-predominante";
import FiltroLaudoAnimais from "../models/filtro-laudo-animais";
import VocacaoPredominante from "../models/vocacao-predominante";
import InfraestruturaExistente from "../models/infraestrututa-existente";

const GATEWAY_V1 = "/s610-gateway-servico/v1";

export async function getDocumentoGed(sicad: number, idDocGed: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/documentos/clientes/${sicad}/ged/${idDocGed}`);
}

export async function getArquivoDocumentoGed(idDocGed: number, formato: string): Promise<any> {
	return api
		.get(`${GATEWAY_V1}/laudos-avaliacoes/documentos/ged/${idDocGed}`, {
			responseType: "blob",
		})
		.then(function (response) {
			const blob = new Blob([response.data], {});
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			document.body.appendChild(a);
			a.href = url;
			a.download = `GED_${idDocGed}.${formato}`;
			a.click();
			window.URL.revokeObjectURL(url);
		});
}

export async function importarOrcamentoGateway(file: FormData, idLaudo: number, idObra: number, tipoImportacao: number, sequencial: number) {
	return api.post(`${GATEWAY_V1}/critica-orcamento/importar-orcamento-proposto/${idLaudo}/${idObra}/${tipoImportacao}/${sequencial}`, file);
}

export async function solicitarDocumentoPendente(solicitacao: SolicitacaoDocumentoPendente): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/documentos/ged/solicitacoes`, solicitacao);
}

export async function getLaudoDadosIniciais(codLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/${codLaudo}`);
}

export async function consultar(filtro: FiltroLaudo): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/consultar`, filtro);
}

export async function getUltimosLaudos(filtro: FiltroLaudoHistorico): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/historicos`, filtro);
}

export async function getObjetivos(): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/dominios/objetivos`);
}

export async function salvarRascunho(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/`, laudo);
}

export async function salvarRascunhoCriticaOrcamento(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/`, laudo);
}

export async function salvarRascunhoParecerTecnico(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/parecer-tecnico/`, laudo);
}

export async function salvarRascunhoAvaliacaoAnimal(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-animais`, laudo);
}

export async function getCategorias(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/detalhamento/categoria/${codigoLaudo}`);
}

export async function obterLaudoVinculadoAvaliacaoQualidade(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-qualidade/laudo-vinculado/${codigoLaudo}`);
}

export async function obterCriticasAvaliacaoQualidade(codigoLaq: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-qualidade/criticas/${codigoLaq}`);
}

export async function salvarRascunhoAvaliacaoDeQualidade(dadosSalvarAQ: EdicaoLaudoAvaliacaoDeQualidadeVO): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-qualidade`, dadosSalvarAQ);
}

export async function concluirAvaliacaoDeQualidade(dadosSalvarAQ: EdicaoLaudoAvaliacaoDeQualidadeVO): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-qualidade/concluir`, dadosSalvarAQ);
}

export async function getOrcamentoPropostoIdentificacaoObra(codigoLaudo): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/orcamentoProposto/${codigoLaudo}`);
}

export async function salvarObraGateway(dadosMetodos): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/obra`, dadosMetodos);
}

export async function deletarObra(codigoObra: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/obra/${codigoObra}`);
}

export async function salvarItemObra(itemObra): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/obra/item`, itemObra);
}

export async function excluirItemObra(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/obra/item/${codigo}`);
}

export async function getExecucaoIdentificacaoObra(codigoLaudo): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/execucao/${codigoLaudo}`);
}

export async function getAcessibilidadeIdentificacaoObra(codigoLaudo): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/acessibilidade/${codigoLaudo}`);
}

export async function concluirLaudoCriticaOrcamento(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/conclusao`, laudo);
}

export async function getMetodosProcedimentos(codigoLaudo): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/metodosProcedimentos/${codigoLaudo}`);
}

export async function concluirLaudo(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/conclusao`, laudo);
}

export async function salvarRascunhoVDR(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/vdr`, laudo);
}

export async function concluirLaudoVDR(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/conclusao/vdr`, laudo);
}

export async function getDetalhesBemPorCodigoExterno(codigoBem: number): Promise<any> {
	if (!codigoBem && codigoBem <= 0) {
		throw new Error("Entradas invalidas");
	}
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/bens/imoveis/externos/${codigoBem}`);
}

export async function getDocumentosViagem(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/${codigoLaudo}/documentos-viagens`);
}

export async function getBensCliente(codClienteSemDigito: string): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/bens/imoveis/clientes/${codClienteSemDigito}`);
}

export async function getTiposImoveis(): Promise<any> {
	return api.get(`${GATEWAY_V1}/dominios/tipo-imoveis`);
}

export async function getAnexo(idLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/avaliacoes-imoveis/anexos/laudo-avaliacao/${idLaudoAvaliacao}`);
}

export async function getAnexoPorLaudo(idLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/avaliacoes-imoveis/anexos/laudo/${idLaudo}`);
}

export async function salvarAnexo(anexo: Anexo): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/avaliacoes-imoveis/anexos/`, anexo);
}

export async function excluirAnexo(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudos-avaliacoes/avaliacoes-imoveis/anexos/${codigo}`);
}

export async function getAnexoFotografico(idLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/anexos-fotografico/laudo-avaliacao/${idLaudoAvaliacao}`);
}

export async function getAnexoFotograficoPorLaudo(idLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/anexos-fotografico/laudo/${idLaudo}`);
}

export async function atualizarAnexoFotografico(anexoFotografico: AnexoFotografico): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/anexos-fotografico/${anexoFotografico.codigo}`, anexoFotografico);
}

export async function excluirAnexoAvaliacaoAnimaisFotografico(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudo-avaliacao-animais/avaliacoes-animais/anexos/${codigo}`);
}

export async function atualizarAnexoAvaliacaoAnimaisFotografico(anexoFotografico: AnexoFotografico): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-animais/anexos-fotografico/${anexoFotografico.codigo}`, anexoFotografico);
}

export async function salvarAnexoFotografico(anexoFotografico: AnexoFotografico): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/anexos-fotografico/`, anexoFotografico);
}
export async function salvarAnexoAvaliacaoAnimaisFotografico(anexoFotografico: AnexoFotografico): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudo-avaliacao-animais/anexos-fotografico/`, anexoFotografico);
}

export async function excluirAnexoFotografico(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudos-avaliacoes/anexos-fotografico/${codigo}`);
}

export async function visualizarLaudoFotograficoPDF(filtro: any): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/visualizarRelatorioFotograficosAIPdf`, filtro, { responseType: "blob" });
}

export async function visualizarLaudoPDF(codigoLaudo: number, isExibeMarcaDagua: boolean): Promise<any> {
	return api.post(
		`${GATEWAY_V1}/laudos-avaliacoes/visualizarLaudoPdf`,
		{ codigoLaudo, isExibeMarcaDagua, sistecWeb: true },
		{
			responseType: "blob",
		}
	);
}


export async function visualizarSolicitacaoLaudoPdf(codigoLaudo: number): Promise<any> {
	return api.post(
		`${GATEWAY_V1}/laudos-avaliacoes/visualizarSolicitacaoLaudoPdf`,
		{ codigoLaudo, sistecWeb: true},
		{
			responseType: "blob",
		}
	);
}

export async function visualizarLaudoRuralPDF(codigoLaudo: number, isExibeMarcaDagua: boolean): Promise<any> {
	return api.post(
		`${GATEWAY_V1}/laudos-avaliacoes/visualizarLaudoRuralPdf`,
		{ codigoLaudo, isExibeMarcaDagua },
		{
			responseType: "blob",
		}
	);
}

export async function visualizarLaudoVdPDF(codigoLaudo: number, isExibeMarcaDagua: boolean): Promise<any> {
	return api.post(
		`${GATEWAY_V1}/laudos-avaliacoes/visualizarLaudoVdPdf`,
		{ codigoLaudo, isExibeMarcaDagua },
		{
			responseType: "blob",
		}
	);
}

export async function getPerfilTecnicoInterno(matricula: string): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/perfil/tecnicoInterno/${matricula}`);
}

export async function visualizarLaudoCriticasPDF(codigoLaudo: number): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/visualizarCriticaPdf`, { codigoLaudo }, { responseType: "blob" });
}

export async function visualizarCriticasPTRPDF(codigoLaudo: number): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/visualizarCriticaPTRPdf`, { codigoLaudo }, { responseType: "blob" });
}

export async function getDominiosVistoriaRural(): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/dominios/vistoria-rural`);
}

export async function consultarVersaoLaudoAvaliacao(): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/versao-avaliacao`);
}

export async function getListagemCriticas(idLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/${idLaudoAvaliacao}/criticas/`);
}

export async function getListagemCriticasObrigatorias(idLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/${idLaudoAvaliacao}/criticas-obrigatorias/`);
}

export async function getListagemCriticasCriticaOrcamento(codigoDACO: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/criticas/${codigoDACO}`);
}

export async function getListagemCriticasAvaliacaoAnimais(codigo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/criticas/${codigo}`);
}

export async function buscarVistoriaLaudo(codigoLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/laudo-avaliacao/${codigoLaudoAvaliacao}`);
}

export async function buscarAcompanhamentosVistoria(codigoVistoria: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/acompanhamentos/${codigoVistoria}`);
}

export async function deleteAcompanhamentoVistoria(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/acompanhamento/excluir/${codigo}`);
}

export async function insertAcompanhamentoVistoria(acompanhamentoVistoria: AcompanhamentoVistoriaDesembolso): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/acompanhamento/incluir`, acompanhamentoVistoria);
}

export async function atualizarAcompanhamentoVistoria(acompanhamentoVistoria: AcompanhamentoVistoriaDesembolso): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/acompanhamento/atualizar`, acompanhamentoVistoria);
}

export async function inserirVistoriaDesembolso(vistoriaDesembolso: VistoriaDesembolso): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/incluirVistoria`, vistoriaDesembolso);
}

export async function buscarImoveisLaudo(codigoVistoria: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/imoveis/${codigoVistoria}`);
}

export async function atualizarImovelLaudo(imovelVistoria: ImovelLaudo): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/vistorias-desembolso-rural/imovel/atualizar`, imovelVistoria);
}

export async function buscarDetalheComprovacaoFisica(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/detalhe-comprovacao-fisica/laudo-avaliacao/${codigoLaudo}`);
}

export async function zerarValoresDetalheComprovacaoFisica(resumoComprovacaoFisica: ResumoComprovacaoFisica): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/detalhe-comprovacao-fisica/zerarValores`, resumoComprovacaoFisica);
}

export async function inserirDetalheComprovacaoFisica(detalhe: DetalheComprovacaoFisicaSubmit): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudos-avaliacoes/detalhe-comprovacao-fisica/incluir`, detalhe);
}

export async function atualizarDetalheComprovacaoFisica(detalhe: DetalheComprovacaoFisicaSubmit): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudos-avaliacoes/detalhe-comprovacao-fisica/atualizar`, detalhe);
}

export async function deletarDetalheComprovacaoFisica(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudos-avaliacoes/detalhe-comprovacao-fisica/excluir/${codigo}`);
}

export async function inserirBaseReferencia(detalhe: BaseReferenciaSubmit): Promise<any> {
	return api.post(`${GATEWAY_V1}/critica-orcamento/base-referencia/incluir`, detalhe);
}

export async function atualizarBaseReferencia(detalhe: BaseReferenciaSubmit): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/base-referencia/atualizar`, detalhe);
}

export async function deletarBaseReferencia(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/base-referencia/excluir/${codigo}`);
}

export async function buscarBaseReferencia(secao: string, codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/base-referencia/${secao}/${codigoLaudo}`);
}

export interface GetQuestionarioRSVD {
	caracteristicaLaudo: string;
	diferencaLaudo: string;
}
export async function buscarQuestionarioUltimaVersaoRespostasSelecionadasVD(params: GetQuestionarioRSVD): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/questionario/ultima-versao/${params.caracteristicaLaudo}/${params.diferencaLaudo}`);
}

export async function buscarQuestionarioPorCodigoRespostasSelecionadasVD(codigo: number, params: GetQuestionarioRSVD): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/questionario/${codigo}/${params.caracteristicaLaudo}/${params.diferencaLaudo}`);
}

export async function buscarRespostasSelecionadasVDPorLaudoAvaliacao(codigoLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/resposta-selecionada-vistoria-desembolso/${codigoLaudoAvaliacao}`);
}

export async function buscarDadosVistoriaDesembolso(codigoLaudoAvaliacao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/dados-vistoria-desembolso/${codigoLaudoAvaliacao}`);
}

export async function buscarCriticasComprovacaoFisicaPorLabuNPreenchidas(codigoLabu: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudos-avaliacoes/critica/criticas-comprovacao-fisica-por-labu/${codigoLabu}`);
}

export async function buscarCoordenadasGeodesicas(codigoDaco: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/coordenadas/${codigoDaco}`);
}

export async function inserirCoordenadasGeodesicas(coordenada: CoordenadasGeodesicas): Promise<any> {
	return api.post(`${GATEWAY_V1}/critica-orcamento/coordenadas`, coordenada);
}

export async function alterarCoordenadasGeodesicas(coordenada: CoordenadasGeodesicas): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/coordenadas`, coordenada);
}

export async function deletarCoordenadasGeodesicas(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/coordenadas/${codigo}`);
}

export async function buscarOrcamentoPropostoVersusReferencia(codigo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/orcamento-sintetico-proposto-vs-referencia/${codigo}`);
}

export async function buscarOrcamentoPropostoVersusReferenciaByCodigoLaudo(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/orcamento-sintetico-proposto-vs-referencia-by-laudo/${codigoLaudo}`);
}

export async function buscarOrcamentoPropostoVersusReferenciaPorMetodosProcedimentos(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/orcamento-sintetico-proposto-vs-referencia/${codigoLaudo}`);
}

export async function inserirOrcamentoPropostoVersusReferencia(orcamentoPropostoVersusReferencia: OrcamentoPropostoVersusReferencia): Promise<any> {
	return api.post(`${GATEWAY_V1}/critica-orcamento/orcamento-sintetico-proposto-vs-referencia`, orcamentoPropostoVersusReferencia);
}

export async function alterarOrcamentoPropostoVersusReferencia(orcamentoPropostoVersusReferencia: OrcamentoPropostoVersusReferencia): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/orcamento-sintetico-proposto-vs-referencia`, orcamentoPropostoVersusReferencia);
}

export async function deletarOrcamentoPropostoVersusReferencia(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/orcamento-sintetico-proposto-vs-referencia/${codigo}`);
}

export async function buscarPendenciasArtsRrts(codigoDaco: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/pendencias/${codigoDaco}`);
}

export async function inserirPendenciasArtsRrts(pendenciasArtsRrts: PendenciasArtsRrts): Promise<any> {
	return api.post(`${GATEWAY_V1}/critica-orcamento/pendencias`, pendenciasArtsRrts);
}

export async function alterarPendenciasArtsRrts(pendenciasArtsRrts: PendenciasArtsRrts): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/pendencias`, pendenciasArtsRrts);
}

export async function deletarPendenciasArtsRrts(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/pendencias/${codigo}`);
}

export async function buscarEsclarecimentosPendencias(codigoDaco: number, identificaEPendencia: boolean): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/esclarecimentosPendencias/${codigoDaco}/${identificaEPendencia}`);
}

export async function inserirEsclarecimentosPendencias(esclarecimentoPendencia: EsclarecimentoPendencia): Promise<any> {
	return api.post(
		`${GATEWAY_V1}/critica-orcamento/esclarecimentosPendencias`,
		esclarecimentoPendencia.esclarecimento ? esclarecimentoPendencia.esclarecimento : esclarecimentoPendencia.pendencia
	);
}

export async function alterarEsclarecimentosPendencias(esclarecimentoPendencia: EsclarecimentoPendencia): Promise<any> {
	return api.put(
		`${GATEWAY_V1}/critica-orcamento/esclarecimentosPendencias`,
		esclarecimentoPendencia.esclarecimento ? esclarecimentoPendencia.esclarecimento : esclarecimentoPendencia.pendencia
	);
}

export async function deleteEsclarecimentosPendencias(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/esclarecimentosPendencias/${codigo}`);
}

export async function inserirParcelaDesembolso(parcela: SugestaoCronogramaDesembolso): Promise<any> {
	return api.post(`${GATEWAY_V1}/critica-orcamento/sugestao-cronograma-desembolso`, parcela);
}

export async function atualizarParcelaDesembolso(parcela: SugestaoCronogramaDesembolso): Promise<any> {
	return api.put(`${GATEWAY_V1}/critica-orcamento/sugestao-cronograma-desembolso`, parcela);
}

export async function deletarParcelaDesembolso(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/sugestao-cronograma-desembolso/${codigo}`);
}

export async function buscarParcelaDesembolso(secao: string, codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/critica-orcamento/sugestao-cronograma-desembolso/${codigoLaudo}`);
}

export async function deletarCracterizacao(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/critica-orcamento/identificacao-obra-caracterizacao/${codigo}`);
}

export async function obterHistoricoRespostas(codigoAvaliacaoQualidade: number, codigoQuestao: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-qualidade/historico-respostas/${codigoAvaliacaoQualidade}/${codigoQuestao}`);
}

export async function buscarDadosVisualizarLaudoPTR(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/parecer-tecnico/visualizar-laudo/${codigoLaudo}`);
}

export async function getListagemCriticasParecerTecnico(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/parecer-tecnico/criticas/${codigoLaudo}`);
}
export async function getAnexoPorLaudoAnimais(idLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/avaliacoes-animais/anexos/laudos-animais/${idLaudo}`);
}

export async function getInformacoesLaudoAnimal(codLaudo: number): Promise<any> {
    return api.get(`/s610-gateway-servico/v1/laudo-avaliacao-animais/${codLaudo}`);
}

export async function buscarDetalheDocumentacaoMetodologiaResultado(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/documento-metodologia-resultado/${codigoLaudo}`);
}

export async function buscarItensPorDominioAnimais(codDominio: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/itens/${codDominio}`);
}

export async function inserirDocumentacaoMetodologiaResultado(documentacaoMetodologiaResultado: DocumentacaoMetodologiaResultado): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudo-avaliacao-animais/documento-metodologia-resultado/`, documentacaoMetodologiaResultado);
}

export async function alterarDocumentacaoMetodologiaResultado(documentacaoMetodologiaResultado: DocumentacaoMetodologiaResultado): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-animais/documento-metodologia-resultado/${documentacaoMetodologiaResultado?.codigoDocMetResult}`, documentacaoMetodologiaResultado);
}

export async function deletarDocumentacaoMetodologiaResultado(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudo-avaliacao-animais/documento-metodologia-resultado/${codigo}`);
}

export async function getInformacoesFinalidade(): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/laudo-avaliacao-animais/finalidades`);
 }

 export async function getMelhoramentosUsosPredominantes(): Promise<{ melhoramentosServicosPublicosVO: MelhoramentosServicosPublicos[], usosPredominantesVO: UsoPredominante[] }> {
	return api.get(`/s610-gateway-servico/v1/laudos-avaliacoes/vistoria/melhoramentos-usos-predominantes`)
		.then(({ data }) => data);
 }

export async function getVocacoesPredominantesInfraenstruturasExistente(): Promise<{ 
	vocacaoPredominanteVO: VocacaoPredominante[], infraestruturaExistenteVO: InfraestruturaExistente[] 
}> {
	return api.get(`/s610-gateway-servico/v1/laudos-avaliacoes/vistoria/vocacoes-infraestruturas`)
	.then(({ data }) => data);
}

 export async function getInformacoesInformacoesEspecies(): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/laudo-avaliacao-animais/vistoria/especie`);
 }

 export async function getCoordenadasApascentamento(codigoLaudoAnimal: number): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/laudo-avaliacao-animais/coordenadas/${codigoLaudoAnimal}`);
 } 

 export async function alterarApascentamento(coordenada: CoordenadasApascentamento): Promise<any> {
	return api.put(`/s610-gateway-servico/v1/laudo-avaliacao-animais/coordenadas`, coordenada);
}

export async function inserirCoordenadasApascentamento(coordenada: CoordenadasApascentamento): Promise<any> {
	return api.post(`/s610-gateway-servico/v1/laudo-avaliacao-animais/coordenadas`, coordenada);
}

export async function deletarCoordenadasApascentamento(codigo: number): Promise<any> {
	return api.delete(`/s610-gateway-servico/v1/laudo-avaliacao-animais/coordenadas/${codigo}`);
}

export async function getInformacoesVistoriaLaudo(codigoLaudoAnimal: number): Promise<any> {
    return api.get(`/s610-gateway-servico/v1/laudo-avaliacao-animais/vistoria/animal/${codigoLaudoAnimal}`);
}

export async function visualizarLaudoFotograficoAnimalPDF(filtro: any): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudo-avaliacao-animais/visualizarRelatorioFotograficosANPdf`, filtro, { responseType: "blob" });
}

export async function buscarDetalhamentoLaudoAnimais(codigoLaudo: number): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/detalhamento/${codigoLaudo}`);
}

export async function inserirDetalhamento(detalhamento: Detalhamento): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudo-avaliacao-animais/detalhamento/`, detalhamento);
}

export async function alterarDetalhamento(detalhamento: Detalhamento): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-animais/detalhamento/${detalhamento?.codigoDetalhamento}`, detalhamento);
}

export async function deletarDetalhamento(codigo: number): Promise<any> {
	return api.delete(`${GATEWAY_V1}/laudo-avaliacao-animais/detalhamento/${codigo}`);
}

export async function getDominiosUnidadeProducao(): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/unidade/producao`);
}

export async function getDominiosUnidadePesoMedio(): Promise<any> {
	return api.get(`${GATEWAY_V1}/laudo-avaliacao-animais/unidade/peso/medio`);
}

export async function visualizarLaudoAnimaisCriticasPDF(codigoLaudo: number): Promise<any> {
	return api.post(`${GATEWAY_V1}/laudo-avaliacao-animais/visualizarCriticaPdfAnimal`, { codigoLaudo }, { responseType: "blob" });
}

export async function concluirLaudoAnimal(laudo: LaudoEdicao): Promise<any> {
	return api.put(`${GATEWAY_V1}/laudo-avaliacao-animais/conclusao`, laudo);
}

export async function visualizarLaudoAnimalPDF(filtroLaudoAnimais: FiltroLaudoAnimais): Promise<any> {
	return api.post(
		`${GATEWAY_V1}/laudo-avaliacao-animais/visualizarRelatorioLaudoAnimaisPdf`, filtroLaudoAnimais, {responseType: "blob"	});
}

export async function getlistarMelhoriaDiagnosticoMetodologiaAIU(): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/laudos-avaliacoes/MelhoriaDgnMet/AIU`);
 }
